/**
 * useCategories Hook
 * 
 * Custom hook for managing categories data and state
 */

import { useQuery } from '@tanstack/react-query';
import { FeedApiService } from '../feedApiService';
import { Category } from '../types';

export const useCategories = () => {
    return useQuery<Category[], Error>({
        queryKey: ['categories'],
        queryFn: FeedApiService.fetchCategories,
        staleTime: 10 * 60 * 1000, // 10 minutes - categories don't change often
        refetchOnWindowFocus: false,
    });
};